import _ from 'lodash'

import module from 'module';

class CustomerService {
  constructor(fileService, notification, popup, $location) {
    this.fileService = fileService;
    this.notification = notification;
    this.popup = popup;
    this.$location = $location;
  }

  // @deprecated. use customer.effectiveName field
  effectiveName(customer) {
    if (customer.customerType === 'INDIVIDUAL') {
      const middleName = customer.individualData.middleName ? customer.individualData.middleName + ' ' : '';
      return `${customer.individualData.firstName} ${middleName}${customer.individualData.lastName}`;
    } else {
      return customer.corporateData.businessName;
    }
  }

  extractPhones(customer) {
    customer.extractedPhones = {
      home: _.find(customer.phones, {type: 'HOME'}),
      work: _.find(customer.phones, {type: 'WORK'}),
      mobile: _.find(customer.phones, {type: 'MOBILE'})
    };
    return customer;
  }

  async redirectWhenProfileIsInvalid(customer) {
    const redirectToProfile = () => this.$location.path(`/customer/${customer.id}/profile`);

    if (!customer.verified) {
      redirectToProfile();
      return;
    }

    if (customer.hasInvalidData || customer.hasExpiredData) {
      this.popup({
        text: `Customer has incomplete or expired profile data. Please update the profile.`,
        callback: redirectToProfile
      });
    }
  }
}

module.service('customerService', CustomerService);
